import React, { useState, useEffect, useRef, useCallback } from "react";
import DynamicTable from "../../../components/admin/Table";
import { useParams } from "react-router-dom";
import Modal from "../../../components/UI/Modal";
import Spinner from "../../../components/UI/Spinner";
import ErrorModal from "../../../components/UI/Error";
import { musicService } from "../../../services";
import { markMusicSeen } from "../../../services/musicService";

const Music = () => {
  // Table data and pagination state.
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [deleteMusic, setDeleteMusic] = useState({});
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError]= useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const { subCat } = useParams();
  
const columns = ['title', 'uploader', 'earnings', 'streams', subCat==="all"? "status":null];

  // Function to fetch data from the API.
  const fetchData = async (pageNumber) => {
    setLoading(true);
   setError(false)
    try {
      let query = ``;
      if (subCat !== "all") {
        query = subCat === "new" ? "?status=new" : "?status=seen";
      }

let musicList=await musicService.allMusic(query)

musicList=musicList.map(music=>{
  music={...music, uploader:music.uploader?.username, earnings:music.totalEarnings || 0, streams:music.totalStreams || 0}
return music;
})
setTableData(musicList)
      //   // Replace this URL with your actual API endpoint.
      //   const response = await fetch(`https://your-api.com/data?page=${pageNumber}`);
      //   const newData = await response.json();
  

      //   if (newData.length === 0) {
      //     setHasMore(false);
      //   } else {
      //     setTableData((prev) => [...prev, ...newData]);
      //   }
    } catch (error) {
      setError(true)
      console.error("Error fetching data:", error);
    }finally{
      setLoading(false);
      setPageLoading(false)
    }
  };

  // Load initial data on component mount.
  useEffect(() => {
    fetchData(page);
  }, [subCat]);

  // Set up the Intersection Observer to detect when the last row is visible.
  const observer = useRef();
  const lastRowRef = useCallback(
    // (node) => {
    //   if (loading) return;
    //   if (observer.current) observer.current.disconnect();

    //   observer.current = new IntersectionObserver((entries) => {
    //     if (entries[0].isIntersecting && hasMore) {

    //       const nextPage = page + 1;
    //       setPage(nextPage);
    //       fetchData(nextPage);
    //     }
    //   });
    //   if (node) observer.current.observe(node);
    // },
    [loading, hasMore, page]
  );
  const handleMarkSeen = async (music) => {
    const musics=[...tableData];
    try {
      const updatedMusic={...music, status:'seen'}
        const updatedMusics=musics.map(obj=>obj._id===updatedMusic._id?updatedMusic:obj)
    await musicService.markMusicSeen(music._id, {staus:"seen"});
         setTableData(updatedMusics)   
    } catch (error) {
      console.log(error);
      setError(true)
      setErrorMessage({title:"Updating Music Status", message:"update this music status"})
      setTableData(musics)
    }
   
  };

  const handleDelete = async () => {  
    const musicList = [...tableData];    
    try {
    const newData = musicList.filter((music) => music._id !== deleteMusic._id);
    setShowModal(false);
    setTableData(newData);
    await musicService.deleteMusic(deleteMusic._id)
    } catch (error) {
      setError(true)
      setErrorMessage({title:"Deleting Music", message:"delete this music"})
      console.log("Unable to delete" + error); 
    }  
  };
  const handleShowModal = (music) => {
    setShowModal(true);
    setDeleteMusic(music);
  };

  const handleClodeModal = () => {
    setShowModal(false);
  };

  const actionsMenu = {
    markSeen:true
  };

  const tableTitle = subCat + " Music";
  const messageTitle=<p className="text-red-500">Comfirm Delete Music</p>;
  const message=<p> Are you sure you want to delete this music:<span className="font-bold text-red-500"> {deleteMusic?.title}</span>?. This action cannot be undone!</p>;

  if (error)
    return (
      <ErrorModal
        isOpen={error}
        onClose={() => setError(false)}
        title={`Error ${errorMessage?.title || "Fetching Music Lists"}`}
        message={
          `There is error while trying to ${errorMessage?.message || "fetch the music lists"}. Please check your internet contivities and refresh this page to try again`
        }
      />
    );
  return (
    <>
      {pageLoading ? (
      <div className="grid place-items-center min-h-[100vh]">  <Spinner /></div>
      ) : (
        <div className="p-4 bg-gray-300  mix-blend-multiply h-full min-h-[100vh]">
          <h1 className="text-xl capitalize font-bold mb-4">{tableTitle}</h1>
          <Modal
            title={messageTitle}
            message={message}
            isOpen={showModal}
            onClose={handleClodeModal}
            comfirmAction={handleDelete}
          />

          <div className="overflow-x-auto">
            <DynamicTable
              columns={columns}
              data={tableData}
              actionsMenu={actionsMenu}
              onDelete={handleShowModal}
              url={"-music"}
              onMarkSeen={handleMarkSeen}
              //   lastRowRef={lastRowRef}
            />
          </div>
          {loading && (
            <div className="flex justify-center mt-4">
              <div
                className="w-8 h-8 border-4 border-blue-500 border-dotted rounded-full animate-spin"
                role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
          {!hasMore && (
            <div className="text-center text-gray-500 mt-4">
              No more data to load.
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Music;
